import { HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "angular-oauth2-oidc";
export class RbsService {
    constructor(http, auth) {
        this.http = http;
        this.auth = auth;
        this.serverUrl = environment.graphql.rbs.url;
        this.graphqlUrl = this.serverUrl;
    }
    queryOrganizations(input) {
        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${this.auth.getAccessToken()}`
        });
        return this.http.post(this.graphqlUrl, {
            query: query_Organizations,
            variables: input
        }, { headers: headers });
    }
    queryUserClaims(input) {
        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${this.auth.getAccessToken()}`
        });
        return this.http.post(this.graphqlUrl, {
            query: query_Claims,
            variables: input
        }, { headers: headers });
    }
    mutationSetAccountLoginDateClaim(input) {
        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${this.auth.getAccessToken()}`
        });
        return this.http.post(this.graphqlUrl, {
            query: set_Account_Login_Date_Claim,
            variables: input
        }, { headers: headers });
    }
}
RbsService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function RbsService_Factory() { return new RbsService(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(i2.OAuthService)); }, token: RbsService, providedIn: "root" });
//
// todo:: *if this grows more than a few, move to a separate file*
//
export const set_Account_Login_Date_Claim = `mutation SetAccountLoginDateClaim($userid: UUID!, $orgid: UUID!) {
    setAccountLoginDateClaim(userid: $userid, orgid: $orgid) {
      data{
        completed
    }
    errors{
        message
        extensions{
            errorCode
            propertyName
            attemptedValue
            severity
        }
      }
    }
  }
`;
export const query_Organizations = `
query organizations($first: Int, $after: String, $last: Int, $before: String, $where: OrganizationFilterInput, $order: [OrganizationSortInput!]){
    organizations(first: $first, after: $after, last: $last, before: $before, where: $where, order: $order){
        pageInfo{
            hasNextPage
            hasPreviousPage
            startCursor
            endCursor
        }
        edges{
            cursor
        }
        nodes{
            orgName
            orgCode
            tpaRule
            tpaRuleFilter
            orgType
            requireMFA
            dateUpdated
            id
            claimPrefix
            dateStart
            dateExpire
            dateCreated
        }
        totalCount
    }
}
`;
export const query_Claims = `
query claims($first: Int, $after: String, $last: Int, $before: String, $where: ClaimFilterInput, $order: [ClaimSortInput!]){
    claims(first: $first, after: $after, last: $last, before: $before, where: $where, order: $order){
        pageInfo{
            hasNextPage
            hasPreviousPage
            startCursor
            endCursor
        }
        edges{
            cursor
        }
        nodes{
            id
            parentId
            key
            value
            isPublic
            dateStart
            dateExpire
            dateCreated
        }
        totalCount
    }
}
`;
